import api from './api';

class CommissionService {
    async getAll() {
        try {
            const response = await api.get('/wallet/commission');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    async getById(id) {
        try {
            const response = await api.get(`/wallet/commission/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    async add(commission_percentage) {
        try {
            const response = await api.post('/wallet/commission', { commission_percentage });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    async update(id, commission_percentage, status) {
        try {
            const response = await api.put(`/wallet/commission/${id}`, { commission_percentage, status });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    async remove(id) {
        try {
            const response = await api.delete(`/wallet/commission/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }
}

export default new CommissionService();